// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__vb2fR","carouselSlide":"Carousel_carouselSlide__a+kPY","active":"Carousel_active__jLecb","button":"Carousel_button__R9ofe"};